import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Switch, Route, useHistory, withRouter } from 'react-router-dom';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import { usuarioActionsSaga } from '../../../../infrastructure/services/usuario';
import { razonSocialActionsSaga } from '../../../../infrastructure/services/razonSocial';
import Alert from '@mui/material/Alert';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Grid from '@mui/material/Grid';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import './index.css'
import { Chip, Divider, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography } from '@mui/material';
import { checkEmail } from '../forms/helpers';
import tkLogo from '../../../../utils/img/tkloginAZ.png';



// Containers
//import { Helmet } from 'react-helmet';



const Login = ({ 
  handleLogin, 
  heandleRecoverPaswoard,
  handlerChangePassword,
  statusConexion, 
  recovery }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [disambled, setDisambled] = useState(true);
  const [estadoLogin, setEstadoLogin] = useState(0);

  const [primerNombre, setPrimerNombre] = useState('');
  const [segundoNombre, setSegundoNOmbre] = useState('');
  const [apellidoMaterno, setApellidoMaterno] = useState('');
  const [apellidoPaterno, setApellidoPaterno] = useState('');
  const [rut, setRut] = useState('');
  const [correo, setCorreo] = useState('');
  const [newUsuario, setnewUsuario] = useState('');
  const [newClave, setNewClave] = useState('');
  const [disambledNuevoUsuario, setDisambledNuevoUsuario] = useState(true);
  const [rutRazonSocial, setRutRazonSocial] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const [passwordRecoveryChange, setPasswordRecoveryChange] = useState('');
  const [passwordRecoveryChangeValid, setPasswordRecoveryChangeValid] = useState(false);
  const [passwordRecoveryChangeRepeat, setPasswordRecoveryChangeRepeat] = useState('');
  const [passwordRecoveryChangeYoken, setPasswordRecoveryChangeYoken] = useState('');
  
  const { recoverPassword } = useSelector((store) => store.tk.sesion);
  const { dataUsuarioRegistrado, dataUsuarioRegistradomensaje } = useSelector((store) => store.tk.usuario);
  const { changePassword } = useSelector((store) => store.tk.sesion);
  const conexionCrearRazonSocial = useSelector((store) => store.tk.razonSocial.conexion);
  const { message, error } = useSelector((store) => store.tk.razonSocial);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChangeUsuario = (event) => {
    setUsuario(event.target.value);
  };
  const handleChangeClave = (event) => {
    setClave(event.target.value);
  };

  const envio = () => {
    handleLogin(usuario, clave);
  };

  useEffect(() => {
    setDisambled(true);
    if (usuario !== '' && clave !== '' && usuario.length >= 5 && clave.length >= 5) {
      setDisambled(false);
    }
  }, [usuario, clave]);


  useEffect(() => {

    primerNombre !== '' &&
      segundoNombre !== '' &&
      apellidoMaterno !== '' &&
      apellidoPaterno !== '' &&
      rut !== '' &&
      correo !== '' &&
      validarCorreo(correo) &&
      newUsuario !== '' &&
      newClave !== '' &&
      newUsuario.length >= 5 &&
      newClave.length >= 5 &&
      rutRazonSocial !== '' &&
      razonSocial !== ''
      ? setDisambledNuevoUsuario(false) : setDisambledNuevoUsuario(true);

    console.log(primerNombre, segundoNombre, apellidoMaterno, apellidoPaterno, rut, correo, newUsuario, newClave);

  }, [primerNombre, segundoNombre, apellidoMaterno, apellidoPaterno, rut, correo, newUsuario, newClave]);

  useEffect(() => {
    if (dataUsuarioRegistrado && dataUsuarioRegistradomensaje == 'Usuario Crado') {
      setEstadoLogin(0);
    }

  }, [dataUsuarioRegistrado, dataUsuarioRegistradomensaje])

  const validarCorreo = (e) => {
    var validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (e.match(validRegex)) {
      return true;
    } else {
      return false;
    }

  }

  const registar = () => {


    const data = {
      "razonSocial": {
        "rut": rutRazonSocial,
        "razonsocial": razonSocial,
        "abog_patroc": `${primerNombre} ${segundoNombre} ${apellidoPaterno} ${apellidoMaterno}`,
        "rut_abog_patroc": rut,
        "abog_deman": `${primerNombre} ${segundoNombre} ${apellidoPaterno} ${apellidoMaterno}`,
        "rut_abog_deman": rut
      },
      "usuario": {
        "primerNombre": primerNombre,
        "segundoNombre": segundoNombre,
        "apellidoPaterno": apellidoPaterno,
        "apellidoMaterno": apellidoMaterno,
        "correo": correo,
        "numeroidentidad": rut,
        "usuario": newUsuario,
        "clave": newClave
      }
    }

    dispatch(razonSocialActionsSaga.activeRazonSocial(data))
  }

  const expUp = /^(?=.*[A-Z])([^\s]){1,12}$/;
  const expLow = /^(?=.*[a-z])([^\s]){1,12}$/;
  const expSim = /^(?=.*[^\w\d\s:])([^\s]){1,12}$/;
  const expNum = /^(?=.*\d)([^\s]){1,12}$/;


  const validateFormatPassword = () => {
    let validate = true;
    const exp = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,16}$/;
    validate = exp.test(passwordRecoveryChange);
    if (passwordRecoveryChange !== passwordRecoveryChangeRepeat && recovery) {
      validate = false;
    }
    setPasswordRecoveryChangeValid(validate);
    console.log(validate);
  };

  useEffect(() => {
    console.log('cambio...', passwordRecoveryChange);
    validateFormatPassword();
  }, [passwordRecoveryChange, passwordRecoveryChangeRepeat]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tokeChange = urlParams.get('token');
    setPasswordRecoveryChangeYoken(tokeChange);
  });


  const reloadLogin = () => {
    sessionStorage.clear();
    history.push(`/`);
    window.location.reload(false);
  }

  const heandleRecover = () => {
    heandleRecoverPaswoard(usuario);
  };

  return (
    <Box
      className='login'
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,/* 
                    width: 'a',
                    height: 228, */
        },

      }}
    >
      <Paper elevation={0} sx={{backgroundColor:'transparent'}}>
        <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 1, width: '30ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={2} >

            <Box className='logo' sx={{paddingTop:.8, margin:5, maxWidth: { xs: '150px', sm: '210px' }}}><img src={tkLogo} alt="TrackingCase" /></Box>
            
            {!recovery && estadoLogin === 0 && (
              <>
                {dataUsuarioRegistrado && (
                  <Alert severity="success">{`El usurio ${primerNombre} ${segundoNombre} ${apellidoMaterno} ${apellidoPaterno} fue creado con exito.`}</Alert>
                )}

                <TextField size="small" id="usuario" label="Usuario" variant="outlined" value={usuario} onChange={(e) => handleChangeUsuario(e)} />
                <FormControl sx={{ m: 1 }} size="small" variant="outlined">
                  <InputLabel htmlFor="password">Clave</InputLabel>
                  <OutlinedInput
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={(
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )}
                    label="Clave"
                    value={clave}
                    onChange={(e) => { handleChangeClave(e); }}
                  />
                </FormControl>
                <Button
                  disabled={statusConexion ? statusConexion : disambled}
                  onClick={() => { envio(); }}
                  variant="contained"
                  className='button-loging'
                >{!statusConexion ? 'Iniciar' : 'Cargando...'}</Button>
                
                <Button
                  onClick={() => { setEstadoLogin(1); setUsuario(''); setClave('') }}
                  variant="text"
                  className='button-olvidastes-contrasenia capitalize margin-top-10'
                >¿Olvidastes tu contraseña?</Button>
                {/* <p className='textAlingCenter margin-top-0'> - o -</p>
                <Button
                  onClick={() => { setEstadoLogin(2); }}
                  variant="contained"
                  className='button-crear-cuenta margin-top-15'
                >Crear una cuenta</Button> */}
              </>

            )}

            {!recovery && estadoLogin === 1 && (
              <>
                <TextField size="small" id="usuario" label="Correo" variant="outlined" value={usuario} onChange={(e) => handleChangeUsuario(e)} />
                <Button
                  disabled={statusConexion || usuario === '' || recoverPassword.result || !checkEmail(usuario)}
                  onClick={() => { heandleRecover(); }}
                  variant="contained"
                  className='button-loging'
                >{!statusConexion ? 'Enviar' : 'Enviando...'}</Button>
                {recoverPassword.result && <Alert severity="success">Te hemos enviado un correo electrónico</Alert>}
                <Button
                  onClick={() => { setEstadoLogin(0); setUsuario('');  }}
                  variant="text"
                  className='button-olvidastes-contrasenia capitalize margin-top-10'
                >{'Regresar al login'}</Button>

              </>

            )}


            {!recovery && estadoLogin === 2 && (

              <>
                <p className='textAlingCenter'>Para poder registrarte es necesario llenar toda la informacion.</p>

                <p className='textAlingCenter'><strong>Datos de empresa.</strong></p>
                <TextField size="small" id="" label="Nombre de la Empresa" variant="outlined" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} />
                <TextField size="small" id="" label="Rut empresa" variant="outlined" value={rutRazonSocial} onChange={(e) => setRutRazonSocial(e.target.value)} />

                <p className='textAlingCenter'><strong>Información del usuario administrador.</strong></p>
                <Grid container padding={0}>
                  <Grid padding={1} paddingLeft={0} xs={6}>
                    <TextField size="small" id="" label="Primer Nombre" variant="outlined" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} />
                  </Grid>
                  <Grid padding={1} paddingRight={0} xs={6}>
                    <TextField size="small" id="" label="Segundo Nombre" variant="outlined" value={segundoNombre} onChange={(e) => setSegundoNOmbre(e.target.value)} />
                  </Grid>
                  <Grid padding={1} paddingLeft={0} xs={6}>
                    <TextField size="small" id="" label="Apellido paterno" variant="outlined" value={apellidoPaterno} onChange={(e) => setApellidoPaterno(e.target.value)} />
                  </Grid>
                  <Grid padding={1} paddingRight={0} xs={6}>
                    <TextField size="small" id="" label="Apellido materno" variant="outlined" value={apellidoMaterno} onChange={(e) => setApellidoMaterno(e.target.value)} />
                  </Grid>
                </Grid>
                <TextField size="small" id="" label="Rut" variant="outlined" value={rut} onChange={(e) => setRut(e.target.value)} />
                <TextField size="small" id="" label="Correo" variant="outlined" value={correo} onChange={(e) => setCorreo(e.target.value)} helperText={correo !== '' && !validarCorreo(correo) && <p className='textAlingCenter noPaddings noMargings colorRed'>Correo invalido.</p>} />
                <TextField size="small" id="usuario" label="Usuario" variant="outlined" value={newUsuario} onChange={(e) => setnewUsuario(e.target.value)} />
                <TextField type={'password'} size="small" id="clave" label="Clave" variant="outlined" value={newClave} onChange={(e) => setNewClave(e.target.value)} />
                {error && message != '' && <Alert severity="error">{message}</Alert>}
                <Button
                  disabled={conexionCrearRazonSocial ? conexionCrearRazonSocial : disambledNuevoUsuario}
                  onClick={() => { registar(); }}
                  variant="contained"
                  className='button-loging'
                >{!conexionCrearRazonSocial ? 'Registrarme' : 'Cargando...'}</Button>
                <Button
                  onClick={() => { setEstadoLogin(0); }}
                  variant="text"
                  className='button-olvidastes-contrasenia capitalize margin-top-10'
                >{'Regresar al login'}</Button>
              </>

            )}

            {recovery && (

              <>
                {changePassword.result && (
                  <Alert severity="success">La clave ha sido creada con éxito</Alert>
                )}
                {!changePassword.result && (
                  <>
                  <Divider>
                  {' '}
                  <Chip label="Recuerda crear una clave segura" size="small" />
                </Divider>
                <FormControl sx={{ m: 1 }} size="small" variant="outlined">
                  <InputLabel htmlFor="passwordRecoveryChange">Nueva Clave</InputLabel>
                  <OutlinedInput
                    id="passwordRecoveryChange"
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={(
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )}
                    label="Nueva Clave"
                    value={passwordRecoveryChange}
                    onChange={(e) => { setPasswordRecoveryChange(e.target.value); }}
                    readOnly={changePassword.result}
                  />
                </FormControl>
                <FormControl sx={{ m: 1 }} size="small" variant="outlined">
                  <InputLabel htmlFor="passwordRecoveryChangeRepeat">Repetir nueva clave</InputLabel>
                  <OutlinedInput
                    id="passwordRecoveryChangeRepeat"
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={(
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )}
                    label="Repetir nueva clave"
                    value={passwordRecoveryChangeRepeat}
                    onChange={(e) => { setPasswordRecoveryChangeRepeat(e.target.value); }}
                    readOnly={changePassword.result}
                  />
                </FormControl>
                {changePassword.error && changePassword.message !== '' && <Alert severity="error">{changePassword.message}</Alert>}
                <Divider>
                  {' '}
                  <Chip label="Tu clave debe contener" size="small" />
                </Divider>
                <Typography sx={{ pt: 2, pb: 0, pl: 1 }} variant="p" component="small">
                  <CheckCircleIcon color={expUp.test(passwordRecoveryChange) ? 'success' : 'disabled'} sx={{ mb: -0.6, fontSize: 15, pr: 0.2 }} />
                  {' '}
                  Al menos un dígito en mayúscula
                </Typography>
                <Typography
                  sx={{
                    pt: 0, pb: 0, mt: 0, pl: 1,
                  }}
                  variant="p"
                  component="small"
                >
                  <CheckCircleIcon color={expLow.test(passwordRecoveryChange) ? 'success' : 'disabled'} sx={{ mb: -0.6, fontSize: 15, pr: 0.2 }} />
                  {' '}
                  Al menos un dígito minúscula
                </Typography>
                <Typography sx={{ pt: 0, pb: 0, pl: 1 }} variant="p" component="small">
                  <CheckCircleIcon color={expNum.test(passwordRecoveryChange) ? 'success' : 'disabled'} sx={{ mb: -0.6, fontSize: 15, pr: 0.2 }} />
                  {' '}
                  Al menos un carácter numérico
                </Typography>
                <Typography sx={{ pt: 0, pb: 0, pl: 1 }} variant="p" component="small">
                  <CheckCircleIcon color={expSim.test(passwordRecoveryChange) ? 'success' : 'disabled'} sx={{ mb: -0.6, fontSize: 15, pr: 0.2 }} />
                  {' '}
                  Al menos un carácter especial
                </Typography>
                <Typography sx={{ pt: 0, pb: 0, pl: 1 }} variant="p" component="small">
                  <CheckCircleIcon color={passwordRecoveryChange !== '' && (passwordRecoveryChange.length >= 8 && passwordRecoveryChange.length <= 12) ? 'success' : 'disabled'} sx={{ mb: -0.6, fontSize: 15, pr: 0.2 }} />
                  {' '}
                  Entre 8 y 12 caracteres
                </Typography>
                <Typography sx={{ pt: 0, pb: 1.5, pl: 1 }} variant="p" component="small">
                  <CheckCircleIcon color={passwordRecoveryChange !== '' && (passwordRecoveryChange === passwordRecoveryChangeRepeat) ? 'success' : 'disabled'} sx={{ mb: -0.6, fontSize: 15, pr: 0.2 }} />
                  {' '}
                  Repetir y recordar tu clave
                </Typography>
                <Button
                  disabled={statusConexion || !passwordRecoveryChangeValid || changePassword.result}
                  onClick={() => { handlerChangePassword(passwordRecoveryChangeYoken, passwordRecoveryChange); }}
                  variant="contained"
                  className="button-loging"
                >
                  {!statusConexion ? 'Crear clave' : 'Cargando...'}
                </Button>
                  </>
                  
                )}
                
                <Button
                  onClick={() => { reloadLogin(); }}
                  variant="text"
                  className="button-olvidastes-contrasenia capitalize margin-top-10"
                  /* disabled={!changePassword.result} */
                >
                  Ir al login
                </Button>
              </>
            )}

          </Stack>

        </Box>

      </Paper>
    </Box>
  );
}

export default Login;